import React from 'react';
import Layout from '../components/layout';
import BusinessCard from '../components/BusinessCard';

export function Info() {
  return (
    <Layout>
      <BusinessCard />
    </Layout>
  );
}

export default Info;
